import {Injectable} from '@angular/core';
import {ConfigService} from './config.service';
import {HttpClient} from '@angular/common/http';
import {UserAddress} from '../model/user-address.model';
import {AddressProof} from '../model/address.proof';
import {JsonPatchBody, PatchOperation} from '../model/json-patch-body.model';
import { UserAddresses } from '../model/user-addresses.model';

@Injectable()
export class UserAddressService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(configService: ConfigService, httpClient: HttpClient) {
        this.configService = configService;
        this.httpClient = httpClient;
    }

    public async create(userAddress: UserAddress, userId: string): Promise<string> {
        const createdUserAddress = await this.httpClient.post<{ id: string }>(`${this.configService.baseUrl()}/user-address?userId=${userId}`, userAddress).toPromise();
        return createdUserAddress.id;
    }

    public async get(addressId: string): Promise<UserAddress> {
        return await this.httpClient.get<UserAddress>(`${this.configService.baseUrl()}/user-address/${addressId}`).toPromise();
    }

    public async getloansApplicationAddressByIds(loansApplicationAddressIds: string[]): Promise<UserAddresses> {
        return await this.httpClient.post<UserAddresses>(`${this.configService.baseUrl()}/user-addresses`, loansApplicationAddressIds).toPromise();
    }

    public async updateAddressProof(addressId: string, addressProof: AddressProof): Promise<void> {
        const baseUrl = this.configService.baseUrl();
        const patchBody: JsonPatchBody = {op: PatchOperation.replace, path: '/addressProof', value: addressProof};

        await this.httpClient.patch(`${baseUrl}/user-address/${addressId}`, [patchBody]).toPromise();
    }

    public async update(updatedUserAddress: UserAddress) {
        const baseUrl = this.configService.baseUrl();
        await this.httpClient.put(`${baseUrl}/user-address/${updatedUserAddress._id}`, updatedUserAddress).toPromise();
    }
}
